import { ReactNode } from 'react';
import { Dialog, OverlayArrow, Popover as AriaPopover } from 'react-aria-components';
import type { PopoverProps as AriaPopoverProps } from 'react-aria-components';



interface PopoverProps extends Omit<AriaPopoverProps, 'children'> {
	children: ReactNode;
	showArrow?: boolean;
}


export function Popover(props: PopoverProps) {
	const { children, className, showArrow = true, ...otherProps } = props;

	return (
		<AriaPopover
			{...otherProps}
			className={`react-aria-Popover${className ? ` ${className}` : ''}`}
		>
			{showArrow &&
				<OverlayArrow>
					<svg width={12} height={12} viewBox="0 0 12 12">
						<path d="M0 0 L6 6 L12 0" />
					</svg>
				</OverlayArrow>
			}
			<Dialog>
				{children}
			</Dialog>
		</AriaPopover>
	);
}